import React from 'react';
import { LegendItem } from '../legend-item/legend-item.js';
import { useLegends } from '../legends-context.js';
function LegendsPreview(props) {
    const context = useLegends();
    if (!props.showPreview) {
        return null;
    }
    const items = context.getItems();
    const shownItems = items.slice(0, props.previewAmount);
    const remainingItems = items.length - shownItems.length;
    return (React.createElement("div", { className: "c-legends__preview" },
        shownItems.map((item) => {
            return (React.createElement(LegendItem, { ...item, key: item.value, notifyLegends: false, size: context.size }));
        }),
        remainingItems > 0 ? (React.createElement("span", { className: "c-legends__preview-tag" }, `${remainingItems}+`)) : null));
}
export { LegendsPreview, };
//# sourceMappingURL=legends-preview.js.map